var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-loader-page',[(!_vm.auth)?_c('layout'):_c('auth-layout'),_c('activity-notifications',{class:{ 'mt-20': _vm.auth}}),_c('portal-target',{attrs:{"name":"modals"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }